export const accommodationTabs = {
  ACCOMMODATION_TAB_SELECTION: 'accommodationTabs.selection',
  ACCOMMODATION_TAB_GO_BACK_DESCRIPTION: 'accommodationTabs.goBackDescription'
}
